/* eslint-disable */
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-action-button-spinner',
    template: `
        <mat-progress-spinner diameter="24" strokeWidth="2.5" mode="indeterminate"></mat-progress-spinner>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionButtonSpinnerComponent {}
